import React from 'react';
import Button from "@material-ui/core/Button";
import {InfoTooltip} from "../tools/InfoToolTip/InfoTooltip";
import {makeStyles} from "@material-ui/styles";

const useStyles = makeStyles(() => (
        {
            addAct: {
                color: '#0A8100',
                border: '1px solid #0A8100'
            }
        }
    )
)

export const CreateActButton = ({disabled, onClick, hidden}) => {
    const classes = useStyles()

    if (hidden) return null

    return <InfoTooltip style={{paddingLeft: 5}}
                        text={'Нажмите для того, чтобы перейти в окно создания акта'}
                        placement={'left'}>
        <span>
          <Button disabled={disabled}
                  onClick={onClick}
                  variant="outlined"
                  classes={{outlined: classes.addAct}}
                  size={'large'}
          >
            Создать акт
        </Button>
        </span>
    </InfoTooltip>
}